<template>
  <div class="loader">
    <beat-loader
      :style="{ height: height }"
      :size="size"
      :color="color"
    ></beat-loader>
  </div>
</template>

<script>
import BeatLoader from "vue-spinner/src/BeatLoader.vue";

export default {
  props: {
    height: {
      type: String,
      default: "auto",
    },
    color: {
      type: String,
      required: false,
      default: "#141E47",
    },
    size: {
      type: String,
      required: false,
      default: "15px",
    },
  },
  components: {
    BeatLoader,
  },
  name: "Loader",
};
</script>

<style scoped lang="scss">
.loader {
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
